import { React } from 'react';
import TypeAnimation from 'react-type-animation';

const Header = () => {
    
    return (
        <>
            <div className='header-wraper' id='header'>
                <div className='main-info'>
                    <h1>Web Development and Websites Promotios</h1>
                </div>
                <TypeAnimation className='type-animation'
                    cursor={false}
                    sequence={[
                        'I am front end developer',
                        3000,
                        'I am react developer',
                        3000,
                    ]}
                    wrapper="p"
                    repeat={Infinity}
                />
                <div className='contact'>
                    <a href="tel:+998911054305" className='btn'>contact me</a>
                </div>
            </div>
        </>
    )
}

export default Header